import { render, staticRenderFns } from "./NavigationProductListV2.vue?vue&type=template&id=204005db&"
import script from "./NavigationProductListV2.vue?vue&type=script&lang=js&"
export * from "./NavigationProductListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports